import { Flex, Text, FlexProps } from "@chakra-ui/react";
import { AirplaneIcon } from "../../ui-elements/airplane-icon/Airplane";

export function FlightSummaryRoute({
  departureAirportIata,
  departureAirportCity,
  arrivalAirportIata,
  arrivalAirportCity,
  isRtl,
  ...props
}: FlexProps & {
  departureAirportIata: string;
  departureAirportCity: string;
  arrivalAirportIata: string;
  arrivalAirportCity: string;
  isRtl: boolean;
}) {
  return (
    <Flex px={{ base: 4, md: 6 }} mb={{ base: 6, md: 8 }} w="full" alignItems="center" {...props}>
      <Flex direction="column" flex="1" alignItems="flex-start">
        <Text color="greyscale.600" fontSize="xl" fontWeight="bold" textColor="font-primary">
          {departureAirportIata}
        </Text>
        <Text color="greyscale.600" fontSize="sm" mt={0}>
          {departureAirportCity}
        </Text>
      </Flex>
      <AirplaneIcon color="primary.500" w={5} h={5} />
      <Flex direction="column" flex="1" alignItems="flex-end">
        <Text color="greyscale.600" fontSize="xl" fontWeight="bold" textColor="font-primary">
          {arrivalAirportIata}
        </Text>
        <Text color="greyscale.600" fontSize="sm" mt={0}>
          {arrivalAirportCity}
        </Text>
      </Flex>
    </Flex>
  );
}
